(function () {
  'use strict';

  var STORAGE_PREFIX = 'lc_diwali_promo_seen_';

  function init(root) {
    if (!root || root.dataset.lcDiwaliInit === 'true') return;
    root.dataset.lcDiwaliInit = 'true';

    var sectionId = root.getAttribute('data-section-id') || 'default';
    var delayMs = Math.max(0, Number(root.getAttribute('data-delay-ms')));
    if (Number.isNaN(delayMs)) delayMs = 0;
    var designMode = root.getAttribute('data-design-mode') === 'true';
    var storageKey = STORAGE_PREFIX + sectionId;

    var dialog = root.querySelector('[data-lc-diwali-dialog]');
    var closeBtn = root.querySelector('[data-lc-diwali-close]');
    var backdrop = root.querySelector('[data-lc-diwali-backdrop]');

    if (!dialog) return;

    function isOpen() {
      return root.classList.contains('is-open');
    }

    function openPopup() {
      if (isOpen()) return;
      root.hidden = false;
      root.classList.add('is-open');
      document.body.classList.add('lc-diwali-promo-open');
      if (closeBtn) closeBtn.focus();
    }

    function closePopup(persist) {
      if (!isOpen()) return;
      root.classList.remove('is-open');
      document.body.classList.remove('lc-diwali-promo-open');
      root.hidden = true;
      if (persist !== false && !designMode) {
        try {
          sessionStorage.setItem(storageKey, '1');
        } catch (e) {
          /* ignore */
        }
      }
    }

    function shouldShow() {
      if (designMode) return true;
      try {
        return sessionStorage.getItem(storageKey) !== '1';
      } catch (e) {
        return true;
      }
    }

    function msSincePageOpen() {
      if (window.performance && typeof performance.timeOrigin === 'number') {
        return Math.max(0, Date.now() - performance.timeOrigin);
      }
      return 0;
    }

    function schedule() {
      if (!shouldShow()) {
        root.hidden = true;
        return;
      }
      root.hidden = true;
      var wait = delayMs;
      if (wait <= 0) {
        if (!shouldShow()) return;
        openPopup();
        return;
      }
      var remaining = Math.max(0, wait - msSincePageOpen());
      window.setTimeout(function () {
        if (!shouldShow()) return;
        openPopup();
      }, remaining);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closePopup(true);
      });
    }
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        closePopup(true);
      });
    }

    root.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && isOpen()) {
        evt.preventDefault();
        closePopup(true);
      }
    });

    schedule();
  }

  function boot() {
    document.querySelectorAll('[data-lc-diwali-promo]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target;
    if (section && section.querySelector) {
      var root = section.querySelector('[data-lc-diwali-promo]');
      if (root) init(root);
    }
  });
})();
